var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "blubber_thread",
      attrs: {
        id: "blubberthread_" + _vm.thread_data.thread_posting.thread_id
      },
      on: {
        dragover: function($event) {
          $event.preventDefault()
          return _vm.dragover($event)
        },
        dragleave: function($event) {
          $event.preventDefault()
          return _vm.dragleave($event)
        },
        drop: function($event) {
          $event.preventDefault()
          return _vm.upload($event)
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [{ name: "scroll", rawName: "v-scroll" }],
          staticClass: "scrollable_area"
        },
        [
          _c("div", { staticClass: "all_content" }, [
            _vm.thread_data.thread_posting.content.trim()
              ? _c("div", { staticClass: "thread_posting" }, [
                  _c(
                    "div",
                    { staticClass: "contextinfo" },
                    [
                      _c("studip-date-time", {
                        attrs: {
                          timestamp: _vm.thread_data.thread_posting.mkdate,
                          relative: true
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.getUserProfileURL(
                              _vm.thread_data.thread_posting.user_username
                            )
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.thread_data.thread_posting.user_name)
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("a", {
                        staticClass: "avatar",
                        style: {
                          backgroundImage:
                            "url(" + _vm.thread_data.thread_posting.avatar + ")"
                        },
                        attrs: {
                          href: _vm.getUserProfileURL(
                            _vm.thread_data.thread_posting.user_username
                          )
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "content",
                    domProps: {
                      innerHTML: _vm._s(_vm.thread_data.thread_posting.html)
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "link_to_comments" })
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.thread_data.thread_posting.content.trim() &&
            !_vm.thread_data.comments.length
              ? _c("div", { staticClass: "empty_blubber_background" }, [
                  _c("div", {
                    domProps: {
                      innerHTML: _vm._s(
                        "Starte die Konversation jetzt!".toLocaleString()
                      )
                    }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "ol",
              { staticClass: "comments", attrs: { "aria-live": "polite" } },
              [
                _vm.thread_data.more_up
                  ? _c(
                      "li",
                      { staticClass: "more" },
                      [
                        _c("studip-asset-img", {
                          attrs: {
                            file: "ajax-indicator-black.svg",
                            width: "20"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.sortedComments, function(comment) {
                  return _c(
                    "li",
                    {
                      key: comment.comment_id,
                      class: comment.class,
                      attrs: { "data-comment_id": comment.comment_id }
                    },
                    [
                      _c("a", {
                        staticClass: "avatar",
                        style: {
                          backgroundImage: "url(" + comment.avatar + ")"
                        },
                        attrs: {
                          href: _vm.getUserProfileURL(comment.user_username),
                          title: comment.user_name
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "content" }, [
                        _c(
                          "a",
                          {
                            staticClass: "name",
                            attrs: {
                              href: _vm.getUserProfileURL(comment.user_username)
                            }
                          },
                          [_vm._v(_vm._s(comment.user_name))]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "html",
                          domProps: { innerHTML: _vm._s(comment.html) }
                        }),
                        _vm._v(" "),
                        _c("textarea", {
                          staticClass: "edit",
                          domProps: { innerHTML: _vm._s(comment.content) },
                          on: {
                            keyup: [
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                if (
                                  $event.ctrlKey ||
                                  $event.shiftKey ||
                                  $event.altKey ||
                                  $event.metaKey
                                ) {
                                  return null
                                }
                                return _vm.saveComment($event)
                              },
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "escape",
                                    undefined,
                                    $event.key,
                                    undefined
                                  )
                                ) {
                                  return null
                                }
                                if (
                                  $event.ctrlKey ||
                                  $event.shiftKey ||
                                  $event.altKey ||
                                  $event.metaKey
                                ) {
                                  return null
                                }
                                return _vm.editComment($event)
                              }
                            ]
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "time" },
                        [
                          _c("studip-date-time", {
                            attrs: { timestamp: comment.mkdate, relative: true }
                          }),
                          _vm._v(" "),
                          comment.writable
                            ? _c(
                                "a",
                                {
                                  staticClass: "edit_comment",
                                  attrs: {
                                    href: "",
                                    title: "Bearbeiten.".toLocaleString()
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.editComment($event)
                                    }
                                  }
                                },
                                [
                                  _c("studip-icon", {
                                    attrs: {
                                      shape: "edit",
                                      size: "14",
                                      role: "inactive"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "answer_comment",
                              attrs: {
                                href: "",
                                title: "Hierauf antworten.".toLocaleString()
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.answerComment($event)
                                }
                              }
                            },
                            [
                              _c("studip-icon", {
                                attrs: {
                                  shape: "export",
                                  size: "14",
                                  role: "inactive"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.thread_data.more_down
                  ? _c(
                      "li",
                      { staticClass: "more" },
                      [
                        _c("studip-asset-img", {
                          attrs: {
                            file: "ajax-indicator-black.svg",
                            width: "20"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              2
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.thread_data.thread_posting.commentable
        ? _c(
            "div",
            { staticClass: "writer" },
            [
              _c("studip-icon", {
                attrs: { shape: "blubber", size: "30", role: "info" }
              }),
              _vm._v(" "),
              _c("textarea", {
                attrs: {
                  placeholder: _vm.thread_data.thread_posting.content.trim()
                    ? "Kommentar schreiben. Enter zum Abschicken.".toLocaleString()
                    : "Nachricht schreiben. Enter zum Abschicken".toLocaleString()
                },
                on: {
                  keyup: [
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      if (
                        $event.ctrlKey ||
                        $event.shiftKey ||
                        $event.altKey ||
                        $event.metaKey
                      ) {
                        return null
                      }
                      return _vm.submit($event)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "up", 38, $event.key, [
                          "Up",
                          "ArrowUp"
                        ])
                      ) {
                        return null
                      }
                      if (
                        $event.ctrlKey ||
                        $event.shiftKey ||
                        $event.altKey ||
                        $event.metaKey
                      ) {
                        return null
                      }
                      return _vm.editPreviousComment($event)
                    },
                    _vm.saveCommentToSession
                  ],
                  change: _vm.saveCommentToSession
                }
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "send",
                  attrs: { title: "Abschicken".toLocaleString() },
                  on: { click: _vm.submit }
                },
                [
                  _c("studip-icon", { attrs: { shape: "arr_2up", size: "30" } })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "upload",
                  attrs: { title: "Datei hochladen".toLocaleString() }
                },
                [
                  _c("input", {
                    staticStyle: { display: "none" },
                    attrs: { type: "file", multiple: "" },
                    on: { change: _vm.upload }
                  }),
                  _vm._v(" "),
                  _c("studip-icon", { attrs: { shape: "upload", size: "30" } })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }